'use client'

import { Header } from '@circlefin/components/lib/Header'

export const CWHeader = Header
export const CWHeaderDescription = Header.Description
export const CWHeaderHead = Header.Head
